import { useState, useEffect, useCallback } from 'react';
import { Plus, Clock } from 'lucide-react';
import api from '../../services/api';
import AddTaskModal from '../ProjectTracking/AddTaskModal';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/** Open Zoho Tasks for this project's Deal — replaces the old free-text Notes
 * column. Adding uses the exact same task modal as Project Tracking. */
export const SpellersTasksCell = ({ zohoProjectId, projectName, testId }) => {
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showAdd, setShowAdd] = useState(false);
  const [tick, setTick] = useState(0);

  const load = useCallback(() => {
    if (!zohoProjectId) { setLoading(false); return; }
    setLoading(true);
    api.get(`${API}/zoho/project/${zohoProjectId}/tasks`, { params: { limit: 20 } })
      .then((r) => setTasks((r.data.tasks || []).filter((t) => t.status !== 'Completed')))
      .catch(() => setTasks([]))
      .finally(() => setLoading(false));
  }, [zohoProjectId, tick]);

  useEffect(() => { load(); }, [load]);

  return (
    <div className="flex items-start justify-between gap-1.5 text-xs" data-testid={testId}>
      <div className="min-w-0 flex-1">
        {loading ? (
          <span className="text-gray-300">…</span>
        ) : tasks.length === 0 ? (
          <span className="text-gray-400">No open tasks</span>
        ) : (
          <div>
            <span className="font-bold text-amber-700 flex items-center gap-1"><Clock className="w-3 h-3" />{tasks.length} open</span>
            <div className="text-gray-500 truncate">{tasks[0].subject}</div>
          </div>
        )}
      </div>
      <button
        onClick={() => setShowAdd(true)}
        className="flex-shrink-0 inline-flex items-center justify-center w-5 h-5 rounded-full text-blue-700 bg-blue-50 border border-blue-300 hover:bg-blue-100 transition-colors"
        title="Add task"
        data-testid={`${testId}-add-btn`}
      >
        <Plus className="w-3 h-3" />
      </button>
      {showAdd && (
        <AddTaskModal
          target={{ type: 'project', module: 'Potentials', id: zohoProjectId, name: projectName }}
          projectId={zohoProjectId}
          onClose={() => setShowAdd(false)}
          onSaved={() => { setShowAdd(false); setTick((t) => t + 1); }}
        />
      )}
    </div>
  );
};

export default SpellersTasksCell;
